import { DESIGN_PERSONALIZATIONS_SET_NAME } from '~/shared/sets/constants'

export const createDesignPersonalizationSet = (designConceptId: string, designPersonalizationContextId: string): Gallery.Models.Url.JSONObject => {
  return {
    name: DESIGN_PERSONALIZATIONS_SET_NAME,
    priority: 1,
    distribution: {
      type: 'positions',
      positions: [1],
      limit: 1,
    },
    ranking: {
      type: 'forced',
      rankingStrategies: [
        {
          name: '',
          sortingDirection: 'descending',
        },
      ],
    },
    filters: {
      content: {
        DesignConceptId: [designConceptId],
      },
    },
    designPersonalizationContextId,
  }
}
